import React from "react";

import PaymentSROInfo from "./PaymentSROInfo";

const PaymentDetailPanel = () => {
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    return (
        <>
            {isModalOpen && <PaymentSROInfo closeModal={() => setIsModalOpen(false)} />}

            <div className='boxPage'>
                <div className='boxHeader'>
                    <h3>Реквизиты оплаты</h3>
                </div>
                <div className='boxMain' style={{fontSize: '14px'}}>
                    <p>Оплата членских и целевых взносов производится в прежнем порядке по выставленному СРО счету или по QR-коду, который можно открыть, нажав кнопку ниже</p>
                </div>
                <div className='boxFooter'>
                    <button type="button" className="button" onClick={() => setIsModalOpen(true)}>
                        Открыть QR-код для оплаты
                    </button>
                </div>
            </div>
        </>
    )
}

export default PaymentDetailPanel;